/**
 * Не требуется тестирования так как все данные приходят их сайд эффектов
 */
// istanbul ignore next
export function isBrowserWindowFullScrolled(): boolean {
  return window.innerHeight + window.scrollY >= document.body.offsetHeight;
}
